import type { AdresseSuggestion } from '~/api/gen'

/** Réponses du géocodeur Géoplateforme relevées sur Arnac-Pompadour (19011) et Guéret (23096). */
export const adresses: AdresseSuggestion[] = [
  {
    label: '15 Rue du Bois Vert 19230 Arnac-Pompadour',
    numero: '15',
    voie: 'Rue du Bois Vert',
    codePostal: '19230',
    ville: 'Arnac-Pompadour',
    codeInsee: '19011',
    latitude: 45.401368,
    longitude: 1.377779,
    precision: 'housenumber',
  },
  {
    label: 'Rue du Bois Vert 19230 Arnac-Pompadour',
    voie: 'Rue du Bois Vert',
    codePostal: '19230',
    ville: 'Arnac-Pompadour',
    codeInsee: '19011',
    latitude: 45.401368,
    longitude: 1.377779,
    precision: 'street',
  },
  {
    label: 'Arnac-Pompadour',
    codePostal: '19230',
    ville: 'Arnac-Pompadour',
    codeInsee: '19011',
    latitude: 45.406925,
    longitude: 1.371913,
    precision: 'municipality',
  },
  {
    label: '2 Avenue de la République 23000 Guéret',
    numero: '2',
    voie: 'Avenue de la République',
    codePostal: '23000',
    ville: 'Guéret',
    codeInsee: '23096',
    latitude: 46.171,
    longitude: 1.871,
    precision: 'housenumber',
  },
  {
    label: 'Guéret',
    codePostal: '23000',
    ville: 'Guéret',
    codeInsee: '23096',
    latitude: 46.1716,
    longitude: 1.8711,
    precision: 'municipality',
  },
]
